import React from "react";
import cn from "classnames";
const Week = ({ weekStart, renderDay, showWeekPicker, className }) => {
    const days = Array.from({ length: 7 }).map((_, i) => weekStart.add(i, "days"));
    return (React.createElement("div", { className: cn("mt-1 flex items-center justify-between", className) },
        showWeekPicker && (React.createElement("div", { className: "flex w-[32px] items-center justify-center" },
            React.createElement("label", { className: "filter-checkbox typography-main" },
                React.createElement("input", { checked: false, type: "checkbox", onChange: () => { } }),
                React.createElement("span", { className: "checkmark" })))),
        days.map((date, index) => (React.createElement("span", { key: index, className: "flex w-[32px] items-center justify-center text-center" }, renderDay(date.format("YYYY-MM-DD")))))));
};
export default Week;
//# sourceMappingURL=Week.js.map